<template>
<div class="mt_140">

        <ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
        <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

        <div class="container">
        <div class="row">
        <div class="col-md-12">

          <!-- row -->
          <div class="row">

              <!-- coluna 2 -->
              <div class="col-md-2">
                <ccMenuConta :num=4></ccMenuConta>
              </div>
              <!-- fim coluna 2 -->

              <!-- coluna 10 -->
              <div class="col-md-10 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

                <div v-if="layout1">
                  <section class="mb-3 travado" v-bind:class="[{travado_div:travado==true}]">

                    <div class="text_laranja text-center mb-3" v-show="loading">
                      <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      Carregando
                    </div>

                    <div class="row mb-3">
                      <div class="col-6 text_13 text_bold text_cinza"> DEPOSITO </div>
                    </div>

                    <div class="card">
                      <div class="card-body">

                        <div class="row mb-4">
                          <div class="col-6">
                            <label class="text_11">Valor R$</label>
                            <input type="text" v-model="valor" class="form-control" placeholder="R$ 0,00">
                          </div>
                          <div class="col-6">
                            <label class="text_11">CPF</label>
                            <input type="text" v-model="cpf" class="form-control disabled text_bold text_12" placeholder="CPF" disabled>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12">
                            <button class="btn btn-outline-success btn-sm w-100 text_12 p-2" v-bind:class="[ valor<=0?'disabled':'' ]" @click="depositar()">SERÁ DEPOSITADO: R$ {{ valor * 1 }}</button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </section>
                </div>

                <div v-show="layout2">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="col-md-12 text_branco mb-2 text_25 text_bold"> Enviar Pix R$ {{ valor }} para: </div>
                      <div class="col-md-12 text_branco mb-1 text_20"> Okto Pagamentos S.A. </div>
                      <div class="col-md-12 text_branco mb-1 text_20"> 44.783.669/0001-72 </div>                      
                      <div class="col-md-12 text_branco mb-2 text_25 text_bold"> Instruções: </div>
                      <div class="col-md-12 text_branco mb-1 text_20"> Vencimento: {{ created }}</div>
                      <div class="col-md-12 text_branco mb-1 text_20"> Pagável até: {{ due }}</div>
                    </div>
                    <div class="col-md-6">
                      <div class="col-md-12 text-center text_branco mb-4">
                        <img :src=qrcodeData alt="Responsive image" :title='"sokkerduel"' width="180px">
                      </div>
                      <div class="col-md-12 text-center text_branco text_25 mb-3">
                        Valor: R$ {{ valor }}
                      </div>

                      <div class="col-12 text-center mb-3">
                        <textarea type="text" ref="copiar" v-model="brcode" rows="10"></textarea>
                      </div>

                      <div class="col-8 offset-2 text-center text_branco mb-3">
                        <button class="btn btn-primary w-100" @click="copy()"> Copiar QR Code</button>
                      </div>

                      <div class="col-8 offset-2 text-center text_branco mb-4">
                        <a :href="link" class="btn btn-info w-100" target="_blank"> Baixar PDF </a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            <!-- fim coluna 10 -->

          </div>
          <!-- fim row -->

      </div>
      </div>
      </div>

    <ccFooter></ccFooter>

</div>
</template>


<script>

import axios from 'axios';
import {TheMask} from 'vue-the-mask';
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import QRCodeVue from 'vue-qrcode-component';
import QRCode from 'qrcode';
import ccFooter from '../layout/footer.vue'

export default {
  data () {
    return {
      titulo: 'DEPOSITO',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: false,
      errors: [],

      nome_completo: null,
      cpf: null,
      valor: '',
      created: null,
      due: null,
      brcode: "00020101021226790014br.gov.bcb.pix2557brcode.starkinfra.com/v2/a4345c1e32f34bb78bd7e58ac51109d95204000053039865802BR5920Okto Pagamentos S.A.6009Sao Paulo62070503***6304B20E",
      link: null,

      travado: false,
      qrcodeData: null,
      qrcodeOptions: {
        version: 10, // Ajuste conforme necessário
      },

      layout1: true,
      layout2: false,
    }
  },

  components: {ccMenu, TheMask, ccMenuConta, ccLoading, ccFooter},

  created()
  {
    document.title = 'Minha Conta: Deposito - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null){ this.user = {} } else { this.user = a }

    this.get_user_completo()
  },

  methods: {

    get_user_completo(){
      this.loading = true;
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'user/completo', header)
      .then(response => {
        this.nome_completo = response.data.resp.nome_completo
        this.cpf = response.data.resp.cpf
        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
        // alert(e)
        this.expluse_para_login()
      });
    },

    depositar() {
      this.loading = true

      let v = this.valor.replace(/,/g, '.')

      var body = {
        name: this.nome_completo,
        taxId: this.cpf,
        amount: v * 100,
        expiration: 3600,
        tags: [
          'sokkerDeskSetDeposit'
        ],
      }

      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.post(this.base_url_api+'set/deposit', body, header)
      .then(response => {

          if (response.status == 200) {

            // Formatar a data e hora
            const createdDateCreated = new Date(response.data.created);
            const formattedDate1 = `${createdDateCreated.getDate().toString().padStart(2, '0')}/${(createdDateCreated.getMonth() + 1).toString().padStart(2, '0')}/${createdDateCreated.getFullYear()} ${createdDateCreated.getHours().toString().padStart(2, '0')}:${createdDateCreated.getMinutes().toString().padStart(2, '0')}:${createdDateCreated.getSeconds().toString().padStart(2, '0')}`;

            const createdDateFina = new Date(response.data.created);
            const formattedDate2 = `${createdDateFina.getDate().toString().padStart(2, '0')}/${(createdDateFina.getMonth() + 1).toString().padStart(2, '0')}/${createdDateFina.getFullYear()} ${createdDateFina.getHours().toString().padStart(2, '0')}:${createdDateFina.getMinutes().toString().padStart(2, '0')}:${createdDateFina.getSeconds().toString().padStart(2, '0')}`;

            this.cod_externo = response.data.id
            this.name = response.data.name
            this.taxId = response.data.taxId
            this.amount = response.data.amount
            this.status = response.data.status
            this.created = formattedDate1
            this.due = formattedDate2
            this.pdf = response.data.pdf
            this.link = response.data.link
            this.brcode = response.data.brcode

            QRCode.toDataURL(this.brcode, (err, url) => {
              if (err) throw err;
              this.qrcodeData = url;
            });

            this.layout1 = false
            this.layout2 = true
            this.loading = false
          }

      })
      .catch(e => {
        console.log(e)
        this.loading = false
      });
    },

    copy(){
      var copyTextarea = this.$refs.copiar
      copyTextarea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'sim!' : 'não!';
        alert(this.brcode);
      } catch (err) {
        alert('Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.');
      }
    },

  }

}

</script>

<style scoped>

  .card{
    background: #FFFFFF08 0% 0% no-repeat padding-box;
    color:#fff;
  }

  input.form-control {
    background: transparent linear-gradient(180deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box;
    color: #909196;
    margin-bottom: 10px;
    border: none;
    padding: 10px;
    font-size: 13px;
  }

  input.form-control.disabled {
    background-color: #21232d;
    background-image: url("../../assets/image/cadeado.svg");
    background-size: 20px;
    background-position: right;
    background-repeat: no-repeat;
  }

  select.form-control {
    background: transparent linear-gradient(180deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box;
    color: #909196;
    margin-bottom: 10px;
    border: none;
    padding: 10px;
    font-size: 13px;
  }

  input.form-control::placeholder {
    color: #B7B7B780;
    font-size: 13px;
  }

  option[value=0] {
    color: red;
  }

  .travado_div{
    pointer-events: none;
    opacity: 0.5;
  }

  textarea{
    color: #ccc;
    background-color: transparent;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/conta/deposito.vue